<template>
  <div>
    <!-- <gSwiper :arr="arr" :maxH="'inherit'"></gSwiper> -->
    <div class="register">
      <Row :gutter="10" class="top">
        <Col span="24">
        <h1 class="title">2026中国国际健康营养博览会 展商报名/China International Health & Nutrition Expo（2026）--Booth Application
        </h1>
        </Col>
        <!-- <Col span="8" class="f-tar">
        <Button shape="circle" style="margin-left:10px" @click="$router.push(`/ex-register-en/register-mobile`)">English</Button>
        </Col> -->
      </Row>
      <registerForm ref="registerForm"></registerForm>
      <registerAddr ref="registerAddr"></registerAddr>

      <div class="tip-info">
        <p>注：</p>
        <p>1.标准展位转角位加收20%/The corner booth will be charged 20% more of the booth fee</p>
        <p>2.展位费外，还将收取1500元注册费（含在线展商手册，展商实名胸卡，会刊百字简介，招商产品在线基础服务，现场产品检索）/Registration Fee ￥1,500（Includes exhibitors'
          manual, exhibitors' badges, 100-word introduction in the conference journal）</p>
        <p>3.最终展位费（含税6%）=展位费+注册费/Total cost = booth fee + registration fee</p>
      </div>

      <div style="display: flex;padding: 15px 15px 25px;">
        <div style="padding-right: 10px;">备注/Notes：</div>
        <div style="flex: 1;">
          <Input v-model="remark" :rows="4" type="textarea" placeholder="请简要输入您对展位的要求" />
        </div>
      </div>
      <div class="f-tac submit-btn">
        <Button type="primary" size="large" long @click="handleSubmit" :loading="loading">Please Confirm And
          Submit</br>确认以上信息，并提交展位申请</Button>
      </div>

    </div>
    <!-- 手机端参展咨询展示业务分类和联系人信息，窄屏自动切换为单列 -->
    <div class="exhibition-contact">
      <div class="contact-list">
        <div class="contact-group">
          <p class="contact-category">保健食品（蓝帽）、海外/进口、健康食/饮品、滋补食品、特医食品/特膳食品</p>
          <div class="contact-people">
            <div class="contact-person">
              <p>敖琳 女士</p>
              <p>电话：(010) 8455 6528</p>
              <p>手机：176-0000-7668</p>
              <p>邮箱：lin.ao@reedsinopharm.com</p>
            </div>
            <div class="contact-person">
              <p>朱溢文 先生</p>
              <p>电话：(010) 8455 6608</p>
              <p>手机：18513864676</p>
              <p>邮箱：yiwen.zhu@reedsinopharm.com</p>
            </div>
          </div>
        </div>
        <div class="contact-group">
          <p class="contact-category">OEM/ODM工厂、原料、益生菌、外用产品、包装、第三方服务</p>
          <div class="contact-people">
            <div class="contact-person">
              <p>真真 女士</p>
              <p>电话：(010) 8455 6650</p>
              <p>手机：13810788430</p>
              <p>邮箱：zhen.zhen@reedsinopharm.com</p>
            </div>
            <div class="contact-person">
              <p>景欣羽 女士</p>
              <p>电话：(010) 8455 6213</p>
              <p>手机：186-1843-4861</p>
              <p>邮箱：xinyu.jing@reedsinopharm.com</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gSwiper from "@components/gSwiper/gSwiper2.vue";
import { mapActions } from "vuex";
import registerForm from "./components/mobile-register-form.vue";
import registerAddr from "./components/mobile-register-addr.vue";
export default {
  name: 'register',
  components: {
    registerForm,
    registerAddr,
    gSwiper,
  },
  data() {
    return {
      loading: false,
      arr: [{ id: 1, path: require('../../../assets/img/banner.png') }],
      remark: ''
    };
  },
  methods: {
    ...mapActions({
      getApplyCompanyRoastCreate: 'registerdModule/getApplyCompanyRoastCreate', // 新增展会接口
    }),
    async handleSubmit() {
      //     console.log( sessionStorage.getItem('exhibitionSelectId'),);
      // debugger
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);
      let res = await this.$refs.registerForm.handleSubmit();
      this.loading = false;
      if (!res.valid) return;
      let res2 = await this.$refs.registerAddr.validHandle();
      this.loading = false;
      if (!res2.valid) return;
      console.log('registerForm', res);
      console.log('registerAddr', res2);
      if(res2.ApplyCompanyOrderNewDto&&res2.ApplyCompanyOrderNewDto.ApplyBoothOrder&&!res2.ApplyCompanyOrderNewDto.ApplyBoothOrder.boothType){
           res2.ApplyCompanyOrderNewDto.ApplyBoothOrder.boothType=res2.ApplyCompanyOrderNewDto.ApplyBoothOrder.boothKind
      }
        console.log('registerAddr', res2);
      let opt = {
        newCompany: { ...res.form, isNeedUpdate: res2.isNeedUpdate, isNeedAngular: res2.isNeedAngular },
        lists: [{
        //   exhibitionId: '09E0218C-C78B-4A55-A329-CA24FBABA3E8',
          exhibitionId: sessionStorage.getItem('exhibitionSelectId'),
          ...res2.ApplyCompanyOrderNewDto,
          remark: this.remark
        }],
        reportType: 'cn'
      };
      console.log('option', opt);
      let bool = await this.getApplyCompanyRoastCreate(opt);
      this.loading = false;
      console.log('getApplyCompanyRoastCreate', bool);
      if (bool && bool.successed) {
        let query =
          "company=" +
          encodeURI(res.form.companyName) +
          "&exname=" +
          encodeURI(res2.exhibition.name) +
          "&exstartTime=" +
          encodeURI(res2.exhibition.startTime) +
          "&exendTime=" +
          encodeURI(res2.exhibition.endTime) +
          "&excity=" +
          encodeURI(res2.exhibition.city) +
          "&exareaName=" +
          encodeURI(res2.ApplyCompanyOrderNewDto.areaName) +
          "&exareaType=" +
          encodeURI(res2.ApplyCompanyOrderNewDto.areaType) +
          "&exshowArea=" +
          encodeURI(res2.ApplyCompanyOrderNewDto.showArea);
        this.$router.push(`/ex-register/register-result?${query}`);
      } else {
        let errTxt = bool.msg || bool.info || "提交失败，请重新尝试！";
        if (bool.errors && bool.errors[0] && bool.errors[0].description) {
          errTxt = bool.errors[0].description;
        }
        this.$Message.error(errTxt);
      }
    },
    IsPC() {
      var userAgentInfo = navigator.userAgent;
      var Agents = ["Android", "iPhone",
        "SymbianOS", "Windows Phone",
        "iPad", "iPod"];
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    }
  },
  created() {
    if (this.IsPC()) {
      this.$router.push(`/ex-register/register`);
    }
    document.title = "NHNE参展报名";
  },
  mounted() { }
}

</script>

<style lang="scss" scoped>
.register {
  max-width: 1200px;
  margin: 0 auto;
  background: #f7f7f7;

  .top {
    padding: 15px;
  }

  .title {
    font-size: 15px;
    color: #333;
    font-weight: bold;
    line-height: 32px;
  }
}

.submit-btn {
  text-align: center;
  padding: 5px 15px 0;

  button {
    background-color: #00a0e9;
    font-size: 15px;
    border-color: #00a0e9;
    margin-bottom: 30px;
    height: 50px;
    color: #fff;
  }
}

.tip-info {
  margin: 25px auto;
  padding: 0 15px;
  white-space: nowrap;
  color: #666;

  p {
    font-size: 12px;
    margin-bottom: 4px;
    white-space: normal;
  }
}

.exhibition-contact {
  padding: 25px 15px 35px;
  background-color: #f5f5f5;
}

.contact-list {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.contact-category {
  margin: 0 0 12px;
  padding: 5px 8px;
  border-radius: 4px;
  background-color: #00a0e9;
  color: #fff;
  font-size: 11px;
  line-height: 1.5;
}

.contact-people {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.contact-person {
  min-width: 0;
  color: #333;

  p {
    margin: 0;
    font-size: 12px;
    line-height: 1.6;

    &:last-child {
      font-size: 11px;
      white-space: nowrap;
    }
  }
}

@media screen and (max-width: 390px) {
  .contact-people {
    grid-template-columns: 1fr;
  }
}
</style>
